/**
* Handle AJAX errors by displaying an alert message.
* @param {object} xhr - The XMLHttpRequest object.
* @param {string} status - The status of the response.
* @param {string} error - The error message.
*/
function handleAjaxError(xhr, status, error) {
    alert("An error occurred: " + error);
}

async function Set_SelectedBranch(itemID, isAuthenticated, token, showPopUp) {
    const APIURL = `/Select?getPopup=${isAuthenticated}`;
    try {
        const response = await fetch(APIURL, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                "RequestVerificationToken": token
            },
            body: JSON.stringify({ ItemID: itemID })
        });

        if (response.ok) {
            Refresh_SearchBox(token);

            // If authenticated, process the popup
            if (isAuthenticated && showPopUp) {
                const html = await response.text();
                showpopup(html);
            }
        } else {
            const errorText = await response.text();
            throw new Error('Failed to update branch: ' + errorText);
        }
    } catch (error) {
        console.error('Error:', error);
    }
}

function Get_SelectedBranchStock(latitude, longitude, productNumber) {
    fetch('/GetBranchStockBySearchTerm', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            "RequestVerificationToken": $("#PDP_API [name='__RequestVerificationToken']").val()
        },
        body: JSON.stringify({ SearchLatitude: latitude, SearchLongitude: longitude, ProductNumber: productNumber })
    })
    .then(response => response.text())
    .then(response => {
        $(".nearby-branches-stock").remove();
        $(".availability-checker").append(response);
    })
    .catch(error => console.error('Error:', error));
}

function AutoFillUsername() {
    const APIURL = '/login/GetRememberMe';
    try {
        fetch(APIURL, {
            method: 'GET',
            headers: {
                "RequestVerificationToken": $("[name='__RequestVerificationToken']").val()
            },
        })
            .then(response => response.text())
            .then(email => {
                if (email && email.trim() !== '') {
                    $('#username_id').val(email);
                    $('#password_id').focus();
                } else {
                    $('#username_id').focus();
                }
            })
            .catch(error => {
                console.log('Error:', error);
            });
    } catch (error) {
        console.log('Error:', error);
    }
}

/**
* Refresh the search box DOM content
*/
function Refresh_SearchBox(token) {
    fetch('/refresh-search-box', {
        method: 'GET',
        headers: {
            "RequestVerificationToken": token
        }
    })
    .then(response => response.text())
    .then(response => $('#branch-selection-container').find(".branch-selection").replaceWith(response));
}

/**
* Refresh the Popular Products DOM content
*/
function Refresh_PopularProducts(token) {
    var path = $('#path_popular_products').val()
    $.ajax({
        type: "GET",
        url: "/refresh-popular-products",
        data: { path: path },
        beforeSend: function (request) {
            request.setRequestHeader("RequestVerificationToken", token);
        },
        success: function (response) {
            $('#PopularProductsWidget').replaceWith(response)
            Refresh_PopularProducts_OwlSlider('#PopularProductsWidget')
        },
        error: handleAjaxError
    });
}

/**
* Refresh the OWL slider
*/
function Refresh_PopularProducts_OwlSlider(containerId) {
    var owl = $(containerId).find('.owl-carousel');
    owl.owlCarousel({
        autoplay: false,
        loop: true,
        nav: true,
        dots: true,
        responsive: {
            1025: {
                dotsEach: 4,
                items: 4.01,
                margin: 19,
                slideBy: 4
            },
            660: {
                dotsEach: 3,
                items: 3.01,
                margin: 16,
                slideBy: 3
            },
            374: {
                dotsEach: 2,
                items: 2.01,
                margin: 16,
                slideBy: 2,
            },
            0: {
                dotsEach: 1,
                items: 1.01,
                margin: 16,
                slideBy: 1,
            }
        },
        slideSpeed: 1000,
        autoplaySpeed: 1000,
        navSpeed: 200,
        fluidSpeed: 1000,
        dotsSpeed: 200,
        smartSpeed: 1000
    });
}

async function encryptData(data, key) {
    try {
        const iv = crypto.getRandomValues(new Uint8Array(16)); // Generate a random IV
        const encoder = new TextEncoder();
        const dataArray = encoder.encode(data);

        const encryptedData = await crypto.subtle.encrypt(
            {
                name: "AES-CBC",
                iv: iv
            },
            key,
            dataArray
        );

        // Convert encrypted data and IV to Base64
        const encryptedBase64 = btoa(String.fromCharCode(...new Uint8Array(encryptedData)));
        const ivBase64 = btoa(String.fromCharCode(...iv));

        return { encryptedBase64, ivBase64 };
    } catch (error) {
        console.error("Encryption error:", error);
        throw error;
    }
}

async function generateKey() {
    const key = await crypto.subtle.generateKey(
        {
            name: "AES-CBC",
            length: 128
        },
        true,
        ["encrypt", "decrypt"]
    );
    return key;
}

function Submit_NPSFeedback(feedback, uniqueID, score) {
    const encodedFeedback = encodeURIComponent(feedback);

    return fetch('/nps/feedback/' + uniqueID + '/score/' + score + '/save', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "RequestVerificationToken": $("[name='__RequestVerificationToken']").val()
        },
        body: JSON.stringify({ Feedback: encodedFeedback, FeedbackUniqueGUID: uniqueID })
    })
    .then(response => {
        if (response.ok) {
            return response.json();  // Return the JSON response if needed
        } else {
            throw new Error('Failed to submit feedback');
        }
    });
}